/* @flow */
import {
  GET_ORDERS, GET_ORDER_BY_ID, SET_CURRENT_ORDER, PLACE_ORDER, CANCEL_ORDER, CONFIRM_ORDER, UPDATE_ORDER
} from '../configs/constants'

export function getOrderById(orderNo) {
  return { type: GET_ORDER_BY_ID, orderNo }
}

export function getOrders(creator) {
  return { type: GET_ORDERS, creator }
}

export function setCurrentOrder(order) {
  return { type: SET_CURRENT_ORDER, order }
}

export function placeOrder(payload) {
  return { type: PLACE_ORDER, payload }
}

export function updateOrder(payload) {
  return { type: UPDATE_ORDER, payload }
}

export function confirmOrder(orderNo) {
  return { type: CONFIRM_ORDER, orderNo }
}

export function cancelOrder(order) {
  return { type: CANCEL_ORDER, order }
}


// WEBPACK FOOTER //
// ./src/actions/order.js